import {HttpEvent, HttpHandlerFn, HttpRequest} from "@angular/common/http";
import {inject} from "@angular/core";
import {Router} from "@angular/router";
import {ConfigurationService} from "@aodocs/configuration-service";
import {InternationalizationService} from "@aodocs/shared-translation";
import { QueryParamRetreiverUtils } from '@aodocs/utils-interceptors';
import {Observable} from "rxjs";

/**
 * TODO: Shouldn't be needed anymore when embedded in end-user app because the URL to access the app will change. So it could be removed.
 * Add preview domain and locale interceptor to be able to add domain and locale to the request to AODocs.
 */
export const addPreviewDomainAndLocaleInterceptor: (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
  intercepted?: string[],
  router?: Router,
  window?: Window,
  i18nService?: InternationalizationService
) => Observable<HttpEvent<unknown>> = (
  request,
  next,
  intercepted = [inject(ConfigurationService).configuration.aodocsApiUrl],
  router = inject(Router),
  window = inject(Window),
  i18nService = inject(InternationalizationService)
) => {
  const isInterceptedUrl = intercepted.some((url) => request.url.includes(url));
  if (isInterceptedUrl) {
    const localeParam = i18nService.currentLocale;
    const regexp = /\/domain\/([^/]*)\//;
    let domainParam = regexp.exec(window.location.href)?.[1];
    if (!domainParam) {
    // On login page, we do not have domain in the path, it is still available in the query params
      domainParam = QueryParamRetreiverUtils.getQueryParamFromRouter('aodocs-domain', router) ||
      QueryParamRetreiverUtils.getQueryParamFromRouter('domain', router);
    }

    // Extract domain from the URL if the route is like 'preview/:domain/...' (the domain is the first path segment after 'preview')
    if(!domainParam) {
    // Extract params from the URL
      const urlTree = router.parseUrl(router.url);
      const primarySegment = urlTree.root.children['primary'];
      if (primarySegment) {
        const segments = primarySegment.segments;
        if (segments.length > 1) {
          domainParam = segments[1].path;
        }
      }
    }
    const newRequest = request.clone({
      setParams: {
        locale: localeParam.replace('-', '_'),
        domain: domainParam || '',
      },
    });
    return next(newRequest);
  }
  return next(request);
};
